import React from 'react'
import PropTypes from 'prop-types'
import chunk from 'lodash/chunk'
import theme from 'Theme'
import { ProductGrid } from 'Blocks'

const SlottedProductGrid = ({
  products = [],
  slots = [],
  className = '',
  pageName = 'compare',
  screenType = 'large'
}) => {
  const itemsPerRow =
    theme.layout.itemsPerRow[pageName][screenType] ||
    theme.layout.itemsPerRow[pageName].fallback
  const chunks = (() => {
    const numberOfChunks = slots.length + 1
    let sectionLength =
      products.length / numberOfChunks -
      ((products.length / numberOfChunks) % itemsPerRow)
    return chunk(products, sectionLength).filter(
      chunk => chunk.length === sectionLength
    )
  })()

  const ProductGridWrapper = ({ products }) => {
    return (
      <ProductGrid
        products={products}
        gaEventContext="Category Page"
        pageName={pageName}
      />
    )
  }

  ProductGridWrapper.propTypes = {
    products: PropTypes.arrayOf(PropTypes.object)
  }

  if (chunks.length > 0) {
    return (
      <div {...{ className }}>
        {slots.map((slot, index) => {
          const gridFirstName = index === 0 && 'first__section'
          return (
            <div
              className={`${gridFirstName} section-group`}
              key={`${index}-group`}
            >
              <ProductGridWrapper products={chunks[index]} />
              <div className="slot">{slot}</div>
            </div>
          )
        })}
        <ProductGridWrapper products={chunks[chunks.length - 1]} />
      </div>
    )
  } else {
    return (
      <ProductGrid
        products={products}
        gaEventContext="Category Page"
        pageName={pageName}
      />
    )
  }
}

SlottedProductGrid.displayName = 'SlottedProductGrid'

SlottedProductGrid.propTypes = {
  className: PropTypes.string,
  pageName: PropTypes.string,
  products: PropTypes.array,
  screenType: PropTypes.string,
  slots: PropTypes.array
}

export default SlottedProductGrid
